import { FC } from 'react'
import { Tooltip } from 'antd'
import { TDnsRecord } from '../types'
import { formatRecordValue } from '../utils'

type Props = {
 records: TDnsRecord[]
 onEdit: (record: TDnsRecord, index: number) => void
 onDelete: (record: TDnsRecord, index: number) => void
}

// "AgentRoof" lock badge for protected records (also used in DNS Records copy)
export const LockTag: FC = () => (
 <span className="lock-tag">
  <i className="fas fa-lock" /> AgentRoof
 </span>
)

// Shared by the connect wizard (step 2) and the live DNS Records section.
// Protected rows (server flag) stay visible but can't be edited or deleted.
const RecordsTable: FC<Props> = ({ records, onEdit, onDelete }) => {
 // Badge column only when a row is protected (never for scanned rows)
 const hasProtected = records.some((record) => record.protected)
 return (
  <table className="domain-records-table">
   <thead>
    <tr>
     <th>Type</th>
     <th>Host</th>
     <th>Value</th>
     {hasProtected && <th aria-label="Managed" />}
     <th aria-label="Actions" />
    </tr>
   </thead>
   <tbody>
    {records.map((record, index) => (
     <tr
      // Scanned rows have no id yet
      // eslint-disable-next-line react/no-array-index-key
      key={record.id ?? `${record.type}-${record.host}-${index}`}
      className={record.protected ? 'protected' : ''}
     >
      <td className="type">{record.type}</td>
      <td className="host">{record.host}</td>
      <td className="val">{formatRecordValue(record)}</td>
      {hasProtected && (
       <td className="managed">
        {record.protected && (
         <Tooltip title="This record is managed by AgentRoof and can't be edited or deleted here.">
          <span>
           <LockTag />
          </span>
         </Tooltip>
        )}
       </td>
      )}
      <td className="actions">
       <button
        type="button"
        className="row-icon-btn"
        aria-label={`Edit ${record.type} record for ${record.host}`}
        disabled={record.protected}
        onClick={() => onEdit(record, index)}
       >
        <i className="fas fa-pen" />
       </button>
       <button
        type="button"
        className="row-icon-btn"
        aria-label={`Delete ${record.type} record for ${record.host}`}
        disabled={record.protected}
        onClick={() => onDelete(record, index)}
       >
        <i className="fas fa-trash" />
       </button>
      </td>
     </tr>
    ))}
   </tbody>
  </table>
 )
}

export default RecordsTable
